export class Foodcourt {
  FoodCourtVendorName: string;
  FromDaysOperation: string;
  ToDaysOperation: string;
  FromTimeOperation: string;
  ToTimeOperation: string;
  title: string;
  ParkId: string;
  IsMarkClosed: string;
  FoodName: string;
  FoodType: string;
  FoodCuisine: string;
  FoodPrice: string;
  FoodDescription: string;
  IsAvailable: string;
  FoodCourtId: string;
  FoodCourtName: string;
}
